<div class="relative h-[40px] min-w-[160px]">
  <!-- Tracker / Button -->
  <div (click)="toggleDropdown()"
    class="flex items-center justify-between w-full h-full bg-slate-50 border border-slate-200 rounded-lg px-3 cursor-pointer hover:bg-white hover:border-blue-400 transition-all shadow-sm"
    [class.border-blue-500]="isOpen" [class.ring-2]="isOpen" [class.ring-blue-100]="isOpen">
    
    <div class="flex items-center">
      <div class="flex items-center text-slate-400 mr-2">
        <i class="fa fa-calendar text-sm"></i>
      </div>

      <span class="text-[13.5px] font-normal text-slate-700 select-none">
        {{ getDisplayLabel() }}
      </span>
    </div>

    <div class="text-slate-400 text-[10px] transition-transform duration-200" [class.rotate-180]="isOpen">
      <i class="fa fa-chevron-down"></i>
    </div>
  </div>

  <!-- Custom Dropdown Menu -->
  <div *ngIf="isOpen"
    class="absolute top-[45px] right-0 w-full bg-white border border-slate-200 rounded-lg shadow-xl z-[99999] animate-[fadeIn_0.15s_ease-out]">
    
    <div class="max-h-[350px] overflow-y-auto py-1">
      <div *ngFor="let option of options" (click)="selectOption(option.value)"
        class="px-3 py-2 flex items-center justify-between transition-colors cursor-pointer text-[12.5px] font-normal text-slate-700 hover:bg-slate-50"
        [class.bg-blue-50]="currentView() === option.value"
        [class.text-blue-600]="currentView() === option.value">
        {{ option.label }}
        <i *ngIf="currentView() === option.value" class="fa fa-check text-xs"></i>
      </div>
    </div>
  </div>
</div>
